export const TESTIMONIALS = [
  {
    quote:
      "NEPHRC delivered our resort with discipline, taste and a commitment to schedule that we rarely see in this region. They feel like a global firm with deeply local insight.",
    name: "Ashok Mehra",
    role: "MD, Hospitality Sponsor",
    org: "Riverside Resort Pvt. Ltd.",
    photo: "https://images.unsplash.com/photo-1556157382-97eda2d62296?q=85&w=400",
  },
  {
    quote:
      "Their DPR cleared every approval window without iteration. The financial model held up under the lender's stress tests — that is rare credibility.",
    name: "Joyita Das, IAS",
    role: "Commissioner",
    org: "Urban Development",
    photo: "https://images.unsplash.com/photo-1573497019418-b400bb3ab074?q=85&w=400",
  },
  {
    quote:
      "The mall opened with 92% leasing — a direct result of NEPHRC's catchment study and tenant mix strategy. Their retail playbook is genuinely world-class.",
    name: "Karan Ahuja",
    role: "Director",
    org: "Lifestyle Mall Developer",
    photo: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=85&w=400",
  },
  {
    quote:
      "Independent third-party monitoring done with rigour and integrity. Their dashboards became the single source of truth across our 12 departments.",
    name: "S. Tongdok",
    role: "CEO",
    org: "Smart City SPV",
    photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=85&w=400",
  },
];
